import { useState, useEffect } from 'react';

const DISMISS_KEY = 'rk-install-dismissed';

function isIos() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent || '');
}

function isStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}

export default function useInstallPrompt() {
  const [installPrompt, setInstallPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    try {
      if (sessionStorage.getItem(DISMISS_KEY) || isStandalone()) return;
    } catch {
      /* ignore */
    }

    if (isIos()) {
      const tmr = setTimeout(() => setIosHint(true), 5000);
      return () => clearTimeout(tmr);
    }

    const handler = (e) => {
      e.preventDefault();
      setInstallPrompt(e);
      setTimeout(() => setShowInstall(true), 2500);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const dismissInstall = () => {
    setShowInstall(false);
    setIosHint(false);
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch {
      /* ignore */
    }
  };

  const handleInstall = async () => {
    if (!installPrompt) return;
    installPrompt.prompt();
    const { outcome } = await installPrompt.userChoice;
    if (outcome === 'accepted') dismissInstall();
  };

  const installVisible = showInstall || iosHint;

  return {
    installVisible,
    iosHint,
    dismissInstall,
    handleInstall,
  };
}
